module.exports = __webpack_public_path__ + "static/assets/79da648dd5a671217fbc71f9d3854817.png";